export interface InstituteBranding {
    company_name?: string;
    short_name?: string;
    company_logo?: string;
    gst_number?: string;
    email?: string;
    phone?: string;
    address?: string;
    footer_content?: string;
}

export function deriveShortName(name?: string | null) {
    const clean = String(name || '').trim();
    if (!clean) return 'Portal';
    const parts = clean.split(/\s+/).filter(Boolean);
    if (parts.length === 1) return clean.slice(0, 16).toUpperCase();
    return parts.slice(0, 3).map((part) => part[0]?.toUpperCase() || '').join('');
}

export function getBrandShortName(config?: InstituteBranding | null) {
    return String(config?.short_name || '').trim() || deriveShortName(config?.company_name);
}

export function getBrandDisplayName(config?: InstituteBranding | null) {
    return String(config?.company_name || '').trim() || getBrandShortName(config);
}

export function getBrandContactLine(config?: InstituteBranding | null) {
    return [config?.phone, config?.email].filter(Boolean).join(' | ');
}

export function getBrandAddressLine(config?: InstituteBranding | null) {
    return String(config?.address || '').trim();
}

export function formatCsvCell(value: string | number | null | undefined) {
    return `"${String(value ?? '').replace(/"/g, '""')}"`;
}

export function buildInstituteCsv(rows: Array<Array<string | number | null | undefined>>, config?: InstituteBranding | null, title?: string) {
    const prelude: Array<Array<string | number | null | undefined>> = [];
    const displayName = getBrandDisplayName(config);
    if (displayName) prelude.push([displayName]);
    if (title) prelude.push([title]);
    const contactLine = getBrandContactLine(config);
    if (contactLine) prelude.push([contactLine]);
    const addressLine = getBrandAddressLine(config);
    if (addressLine) prelude.push([addressLine]);
    if (config?.gst_number) prelude.push([`GSTIN: ${config.gst_number}`]);
    if (config?.footer_content) prelude.push([config.footer_content]);
    if (prelude.length) prelude.push([]);
    return [...prelude, ...rows].map((row) => row.map(formatCsvCell).join(',')).join('\n');
}
